import Fallback from "app/components/Fallback";
import React from "react";
import SchoolProfile from "./SchoolProfile";

const Schools = React.lazy(() => import("app/modules/schools/pages/Schools"));
const AboutSchool = React.lazy(() =>
  import("app/modules/website-builder/aboutUs/AboutSchool")
);

const BillsUsage = React.lazy(() =>
  import("app/modules/schools/pages/billsUsage/BillsUsage")
);

export const SchoolsPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Schools {...props} />
  </React.Suspense>
);

export const AboutSchoolPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <AboutSchool {...props} />
  </React.Suspense>
);
export const SchoolProfilePage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <SchoolProfile {...props} />
  </React.Suspense>
);

export const BillsUsagePage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <BillsUsage {...props} />
  </React.Suspense>
);
